import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withKeys as _withKeys, mergeProps as _mergeProps, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icons/imagefile-icon.svg'
import _imports_1 from '../../assets/icons/comment.svg'
import _imports_2 from '../../assets/icons/cancel.svg'
import _imports_3 from '@/assets/icons/dots.svg'


const _withScopeId = n => (_pushScopeId("data-v-85956e94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "messagechat__img" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "messagechat__heading" }
const _hoisted_4 = { class: "messagechat__heading__title" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "group_names"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "messagechat__right" }
const _hoisted_9 = ["src", "diabled"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  class: "messagechat__section"
}
const _hoisted_13 = {
  key: 0,
  class: "archive_notification"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Your chat has been archived.", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 0,
  class: "nomessage__wrapper"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nomessage__text" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "comment__icon" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Your messages will appear here")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nomessage__note" }, [
  /*#__PURE__*/_createElementVNode("p", null, " This chat is end-to-end encrypted & monitored by iknowa platfrom. ")
], -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "nomessage__wrapper"
}
const _hoisted_21 = { class: "nomessage__note !tw-w-full !tw-max-w-[unset] !tw-m-0" }
const _hoisted_22 = {
  key: 2,
  class: "dispute_project_wrapper"
}
const _hoisted_23 = { class: "tw-w-full tw-p-3 tw-box-border tw-bg-[rgba(59,103,233,0.08)] tw-border-[#3B67E9] tw-border-[1px] tw-border-solid tw-rounded-lg tw-flex tw-gap-2 tw-items-center" }
const _hoisted_24 = {
  key: 3,
  class: "dispute_project_wrapper"
}
const _hoisted_25 = { class: "tw-w-full tw-p-3 tw-box-border tw-bg-[rgba(59,103,233,0.08)] tw-border-[#3B67E9] tw-border-[1px] tw-border-solid tw-rounded-lg tw-flex tw-gap-2 tw-items-center" }
const _hoisted_26 = {
  key: 4,
  class: "dispute_project_wrapper"
}
const _hoisted_27 = { class: "tw-w-full tw-p-3 tw-box-border tw-bg-[rgba(59,103,233,0.08)] tw-border-[#3B67E9] tw-border-[1px] tw-border-solid tw-rounded-lg tw-flex tw-gap-2 tw-items-center" }
const _hoisted_28 = {
  key: 5,
  class: "dispute_project_wrapper"
}
const _hoisted_29 = {
  key: 0,
  class: "message__date"
}
const _hoisted_30 = {
  key: 1,
  class: "message__date"
}
const _hoisted_31 = { class: "messagechat__bottom__chats__list" }
const _hoisted_32 = { class: "messagechat__left" }
const _hoisted_33 = { class: "messagechat__img" }
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "messagechat__center" }
const _hoisted_36 = { class: "messagechat__heading" }
const _hoisted_37 = { class: "messagechat__right" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "View Offer", -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "messagechat_attachment" }
const _hoisted_43 = { class: "messagechat_attachment__content" }
const _hoisted_44 = { class: "dox__icon" }
const _hoisted_45 = ["src"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "" }, " Eveidence submitted ", -1))
const _hoisted_47 = { class: "tw-relative tw-w-[22px] tw-shrink-0 tw-block" }
const _hoisted_48 = ["src"]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "View Evidence", -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = {
  key: 0,
  class: "dox_preview"
}
const _hoisted_53 = { class: "dox_icon" }
const _hoisted_54 = ["src"]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_56 = {
  key: 1,
  class: "messagechat__complete"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " This project related to this chat is finished. You can’t reply to this conversation. ", -1))
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = {
  key: 2,
  class: "messagechat__edit"
}
const _hoisted_60 = { class: "messagechat__icons" }
const _hoisted_61 = { class: "emoji__wrapper" }

import chatService from "../services/chat.service";
import { onBeforeMount, ref, computed, onBeforeUnmount } from "vue";
import {
  displayToastMessage,
  documentExtensions,
  getImageApiUrl,
  getImageStringToImageURL,
  imageExtensions,
  setDirectStoragePathToImage,
} from "@/core/utils/common";
import $axios from "@/core/utils/axios-api-config";
import CommonLoader from "./CommonLoader.vue";

import "vue3-emoji-picker/css";
import { WORKSTATION } from "@/store/modules/workstation";
import { useStore } from "vuex";
import { onMounted } from "vue";
import { inject } from "vue";
import { UserRolesEnum } from "../enums/RolesEnum";
import { USER_STORE } from "@/store/modules/user";
import UserProfileLogo from "@/core/components/UserProfileLogo.vue";
import {
  ChatTypeEnum,
  UserMessagesGroupTypeEnum,
  UserMessagesRoomStatusEnum,
} from "../enums/chatsEnums";
import { watch } from "vue";
import moment from "moment";
import { nextTick } from "vue";
import { ElMessage } from "element-plus";
import EmojiPicker from "vue3-emoji-picker";
import CloseDisputeModal from "@/core/components/CloseDisputeModal.vue";
import { PROJECT_STORE } from "@/store/modules/project";
import MakeDisputeOfferModel from "@/core/components/MakeDisputeOfferModel.vue";
import ViewOfferProjectModel from "@/core/components/ViewOfferProjectModel.vue";
import { DisputeRequestStatusEnums } from "../enums/ProjectsEnum";
import Button from "./ui/general/Button.vue";
import Text from "./ui/general/Text.vue";
import { CHATMESSAGE } from "@/store/modules/chat-message";
import ConfirmRejectDisputeModal from "./ConfirmRejectDisputeModal.vue";
import InfoIcon from "./icons/InfoIcon.vue";
import { getCurrentInstance } from "@vue/runtime-core";
import { DisputeTypeEnums } from "@/core/enums/disputeEnum";
import ViewEvidenceAttachmentModal from "@/core/components/ViewEvidenceAttachmentModal.vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageChatComponent',
  props: {
  userAllMessages: {
    type: Array,
  },
  receiverUserWorkstation: {
    type: Object,
    default: null,
  },
  senderUserWorkstation: {
    type: Object,
    default: null,
  },
  userMessageRoomDetails: {
    type: Object,
    default: null,
  },
  projectId: {
    type: Number,
  },
  userImagesMap: {
    type: Object,
    default: null,
  },
  groupNetWorkContactList: {
    type: Array,
  },
  filterMessagesRooms: {
    type: Array,
  },
},
  emits: [
  "closeMessageChatBox",
  "saveNewGroupMembers",
  "onClickVideoCallButton",
  "onClickVideoCallButton",
  "getUserWorkStationProfileImage",
  "on-success-close-dispute-request",
],
  setup(__props, { emit: __emit }) {

const props = __props;
const emits = __emit;

const store = useStore();
const internalInstance = getCurrentInstance();
const isShowMessage = ref(true);
const inputNewMessage = ref("");
const userMessages = ref([]) as any;
const fileInputRef = ref(null) as any;
const chatContainer = ref(null) as any;
const isEmojiKeyboard = ref(false);
const previousDate = ref(null) as any;
const attachmentFile = ref(null) as any;
const isLoading = ref(false);
const loading = ref(false);
const groupsMemberDetails = ref(null) as any;
const isNewGroupMembers = ref(false);
const isAddNewGroupMember = ref(false);
const selectedItems = ref([]) as any;
const attachmentImageUrl = ref("");
const memberSearching = ref();
const mediaSearch = ref("");
const attachmentDownloadLoadingArray = ref([]) as any;
const isGroupUserChat = ref(false);
const toggleShowText = ref(null) as any;
const isShowCloseDisputeModal = ref(false);
const isShowOfferDisputeModal = ref(false);
const hasPendingDisputeOffer = ref(false);
const hasCloseDisputeProposal = ref(false);
const hasDisputeRaise = ref(false);
const isImCloseDisputeRequestSender = ref(false);
const closeProposalData = ref(null) as any;
const isViewOfferModal = ref(false);
const selectedUserMessage = ref(null) as any;
const isShowConfirmRejectCloseDisputeModal = ref(false);
const isViewEvidenceModal = ref(false);

const disputeIssueId = ref(null);
const disputeDetails = ref(null) as any;
const route = useRoute();
// let emojiIndex = new EmojiIndex(data);
const isCompleteChat = ref(false);
const onSelectEmoji = (e: any) => {
  if (
    props.userMessageRoomDetails.chatType === ChatTypeEnum.DISPUTE_PROJECT &&
    isDisputeAccepted
  ) {
    return;
  }

  inputNewMessage.value += e.i;
};
const closeMessageBox = (msgId: any) => {
  emits("closeMessageChatBox", msgId);
};
const closeNewGroupModal = () => {
  isNewGroupMembers.value = false;
  isAddNewGroupMember.value = false;
  selectedItems.value = [];
};
const groupNetWorkContactList = computed(() => {
  const data = props.groupNetWorkContactList.filter((contact: any) => {
    if (contact?.isUserChat)
      return !groupsMemberDetails.value?.groupMembers.some(
        (member: any) =>
          member.type === UserMessagesGroupTypeEnum.USER &&
          member.user.id === contact.receiverWorkstation.user.id
      );
    else
      return !groupsMemberDetails.value?.groupMembers.some(
        (member: any) =>
          member.type === UserMessagesGroupTypeEnum.WORKSTATION &&
          member.userWorkStation.id === contact.receiverWorkstation.id
      );
  });

  if (groupsMemberDetails.value.isUserChat)
    return data.filter((member: any) => member.isUserChat);
  else return data.filter((member: any) => !member.isUserChat);
});
//filter with both users and workstation
const filterGroupNetWorkContactList = computed(() =>
  !memberSearching.value && isAddNewGroupMember.value
    ? groupNetWorkContactList.value
    : groupNetWorkContactList.value?.filter(
        (contact: any) =>
          contact?.receiverWorkstation?.name
            .toLowerCase()
            .includes(memberSearching.value.toLowerCase().trim()) ||
          contact.receiverWorkstation?.user?.firstName
            .toLowerCase()
            .includes(memberSearching.value.toLowerCase().trim()) ||
          contact.receiverWorkstation?.user?.lastName
            .toLowerCase()
            .includes(memberSearching.value.toLowerCase().trim())
      )
);

const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);
const isChecked = computed(() => {
  return (item: any) => selectedItems.value.includes(item);
});
const isAddedContact = (item: any) => {
  const index = selectedItems.value.findIndex(
    (selectedItem: any) => selectedItem === item
  );
  return index === -1;
};

const isImageType = (publicURL: any) => {
  return imageExtensions.some((ext) => publicURL?.toLowerCase().endsWith(ext));
};

const updateSelectedItems = (item: any) => {
  const index = selectedItems.value.findIndex(
    (selectedItem: any) => selectedItem === item
  );
  if (index !== -1) {
    selectedItems.value.splice(index, 1);
  } else {
    selectedItems.value.push(item);
  }
  // }
};

const addNewGroupMembers = async () => {
  const users = [] as any;
  selectedItems.value.map((item: any) => {
    users.push({
      isUserChat: item?.isUserChat,
      userId: item?.receiverWorkstation?.user?.id,
      workstationId: item?.receiverWorkstation?.id,
    });
  });
  try {
    const formData = {
      groupId: groupsMemberDetails.value.id,
      projectId: props.userMessageRoomDetails?.project?.id,
      users,
    };
    emits("saveNewGroupMembers", formData);
    closeNewGroupModal();
  } catch (error) {
    console.log(error);
  }
};
const closeEmojiPicker = (e: any) => {
  const isClickOnDotsButton = document
    .getElementById("click-outside")
    ?.contains(e.target);
  if (!isClickOnDotsButton) {
    isEmojiKeyboard.value = false;
  }
};
const toggleMessages = () => {
  isShowMessage.value = !isShowMessage.value;
};
const toggleViewEvidenceModal = () => {
  isViewEvidenceModal.value = !isViewEvidenceModal.value;
};
const newMessagePayload = computed(() => {
  return {
    userMessageRoomId: props.userMessageRoomDetails?.id,
    projectId: props?.projectId,
    toWorkstationId: props.receiverUserWorkstation?.id,
    fromWorkstationId: props.senderUserWorkstation?.id,
    toUser: props.receiverUserWorkstation?.user?.id,
    fromUser: props.senderUserWorkstation?.user?.id,
    state: "unread",
    isUserChat: props.receiverUserWorkstation?.isUserChat,
  };
});
const getTimeElapsedString = (timestamp: any) => {
  const previous = new Date(timestamp) as any;
  const current = new Date() as any;

  const elapsed = current - previous;

  const seconds = Math.floor(elapsed / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const weeks = Math.floor(days / 7);
  if (weeks > 0) {
    return weeks === 1 ? "1 week ago" : `${weeks} weeks ago`;
  } else if (days > 0) {
    return days === 1 ? "1 day ago" : `${days} days ago`;
  } else if (hours > 0) {
    return hours === 1 ? "1 hour ago" : `${hours} hours ago`;
  } else if (minutes > 0) {
    return minutes === 1 ? "1 minute ago" : `${minutes} minutes ago`;
  } else {
    return "Just now";
  }
};
const shouldDisplayDate = (message: any, index: any) => {
  if (index === userMessages.value.length - 1) {
    previousDate.value = new Date(message.dateCreated).getDate();
    return true;
  } else {
    const previousMessage = userMessages.value[index + 1];
    if (previousMessage) {
      const previousDay = new Date(previousMessage.dateCreated).getDate();
      const currentDay = new Date(message.dateCreated).getDate();
      if (currentDay !== previousDay) {
        previousDate.value = currentDay;
        return true;
      } else {
        return false;
      }
    }
  }
};
const getTheDay = (timestamp: any) => {
  const currentDate = new Date() as any;
  const messageDate = new Date(timestamp) as any;

  currentDate.setUTCHours(0, 0, 0, 0);
  messageDate.setUTCHours(0, 0, 0, 0);

  const differenceInTime = currentDate.getTime() - messageDate.getTime();
  const differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24));

  if (differenceInDays === 0) {
    return "Today";
  } else if (differenceInDays === 1) {
    return "Yesterday";
  } else {
    const options = { month: "long", day: "numeric" };
    return messageDate.toLocaleDateString("en-US", options);
  }
};

const downloadAttachment = async (data: any) => {
  const { attachment, originalName, id } = data;
  attachmentDownloadLoadingArray.value.push(id);
  const imageUrl = getImageApiUrl(attachment, true);

  try {
    const response: any = await $axios.get(imageUrl);
    const blob = new Blob([new Uint8Array(response.Body.data)]);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = originalName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  } catch (error) {
    console.error("Error downloading image:", error);
  } finally {
    attachmentDownloadLoadingArray.value = [
      ...attachmentDownloadLoadingArray.value.filter((el: any) => el !== id),
    ];
  }
};
const deleteAttachment = async (message: any) => {
  try {
    if (!message) return;

    messageMediaList.value = messageMediaList.value.map((entry: any) => {
      entry.mediaList = entry.mediaList.filter(
        (media: any) => media.id !== message.id
      );
      return entry;
    });

    userMessages.value = userMessages.value.filter(
      (data: any) => data.id !== message.messageId
    );

    await chatService.deleteUserMessage(message.messageId);
  } catch (error) {
    console.log("error", error);
  }
};

const formatDate = (dateString: any) => {
  const date = dateString ? moment(dateString) : moment();
  return date.format("DD-MM-YYYY HH:mm");
};
const saveNewMessage = async (isEvent: boolean, event: any) => {
  if (isEvent) {
    if (event.shiftKey) {
      return;
    } else {
      event.preventDefault();
    }
  }
  let attachedFile = attachmentFile.value;
  attachmentFile.value = null;
  if (!attachedFile && inputNewMessage.value.trim() === "") {
    return;
  }

  try {
    const payload = {
      ...newMessagePayload.value,
      messageId: `${new Date().getTime()}`,
      content: inputNewMessage.value,
    };

    let responseMessage = (await chatService.createUserMessage(payload)) as any;
    if (!responseMessage) return;

    scrollBottom();

    if (attachedFile && responseMessage) {
      const fileExtension = attachedFile.name.split(".").pop().toLowerCase();

      const validExtensions = [...imageExtensions, ...documentExtensions];
      // Check if the file extension is in the allowed list
      if (!validExtensions.includes(fileExtension)) {
        ElMessage.error("Invalid file type. Please select a valid file");
        return;
      }

      const userWorkstationId = props.senderUserWorkstation?.id;
      const userMessageRoomId = props.userMessageRoomDetails?.id;
      const userMessageId = responseMessage?.id;
      const formData = new FormData();
      formData.append("file", attachedFile);
      responseMessage.userMessageRoom.userMessageAttachments = [];
      responseMessage.userMessageRoom.userMessageAttachments.push({
        originalName: attachedFile.name,
      });
      userMessages.value.unshift(responseMessage);
      isLoading.value = true;
      const attachmentResponse =
        (await chatService.createUserMessageRoomAttachment(
          userWorkstationId,
          userMessageRoomId,
          userMessageId,
          formData
        )) as any;
      isLoading.value = false;
      if (attachmentResponse) {
        const findMessage = userMessages.value.find(
          (msg: any) => msg.id === userMessageId
        );
        findMessage.userMessageRoom.userMessageAttachments = [];
        findMessage.userMessageRoom.userMessageAttachments.push(
          attachmentResponse
        );
      }
    } else {
      userMessages.value.unshift(responseMessage);
    }
  } catch (error) {
    console.log(error);
  } finally {
    if (attachedFile) {
      await setMessageMediaList();
    }
    attachedFile = null;
    isLoading.value = false;
    inputNewMessage.value = "";
  }
};

const getImagePublicUrl = (profileImage: string | null) => {
  if (!profileImage) return require("@/assets/images/user-placeholder.png");

  const imgUrl = props.userImagesMap[profileImage];
  if (!imgUrl) return require("@/assets/images/user-placeholder.png");

  return imgUrl;
};

const pusher = inject("pusher") as any;
const subscribeGroupChannelList = ref([]) as any;
const subscribeDisputeProjectChannelList = ref([]) as any;
const unbindSubscribeGroupChannelList = () => {
  if (subscribeGroupChannelList.value.length) {
    subscribeGroupChannelList.value.forEach((channel: any) => {
      // Unbind all events from channel
      channel?.unbind();
      pusher?.unsubscribe(channel.name);
    });
    subscribeGroupChannelList.value.length = [];
  }
};
const unbindSubscribeDisputeProject = () => {
  if (subscribeDisputeProjectChannelList.value.length) {
    subscribeDisputeProjectChannelList.value.forEach((channel: any) => {
      channel?.unbind();
      pusher?.unsubscribe(channel.name);
    });
    subscribeDisputeProjectChannelList.value.length = [];
  }
};

const subscribeGroupMessage = () => {
  const roomChannel = pusher?.subscribe(
    `group-messages-${props.userMessageRoomDetails?.id}`
  );
  roomChannel
    ?.unbind("group.new.member")
    ?.bind("group.new.member", async (newGroupMembers: any) => {
      if (newGroupMembers) {
        ////Todo : add member instead of call api
        await getUserGroupMembers(props.userMessageRoomDetails?.id);
      }
    });
  roomChannel
    ?.unbind("group.delete.member")
    ?.bind("group.delete.member", async (newGroupMembers: any) => {
      if (newGroupMembers) {
        //Todo : filter member instead of call api
        await getUserGroupMembers(props.userMessageRoomDetails?.id);
      }
    });
  subscribeGroupChannelList.value.push(roomChannel);
};

const subscribeDisputeProjectRequest = () => {
  const roomChannel = pusher?.subscribe(
    `dispute-project-${props.userMessageRoomDetails.id}-${props.userMessageRoomDetails.project?.id}`
  );
  roomChannel
    ?.unbind("dispute.project.room")
    ?.bind("dispute.project.room", (disputeData: any) => {
      if (disputeData && disputeData.type === "close-dispute-project") {
        const closeProposal = disputeData?.dispute?.close_proposal;
        const disputePayload = {
          id: props.userMessageRoomDetails.id,
          dispute: {
            ...props.userMessageRoomDetails.dispute,
            close_proposal: closeProposal ? [closeProposal] : [],
          },
        };
        closeProposalData.value = closeProposal;
        hasCloseDisputeProposal.value = true;
        isImCloseDisputeRequestSender.value =
          closeProposal?.userWorkstation.id === activeUserWorkstation?.value.id;

        store.commit(
          `${CHATMESSAGE}/updateDisputeChatMessageRoom`,
          disputePayload
        );
        if (route.name === "projectDetails" || route.name === "jobDetails") {
          store.dispatch(`${PROJECT_STORE}/getDisputeProject`, {
            projectRefId: route?.params?.refId,
          });
        }
      } else if (disputeData && disputeData.type === "accept-dispute-project") {
        const disputePayload = {
          id: props.userMessageRoomDetails.id,
          dispute: {
            ...props.userMessageRoomDetails.dispute,
            disputeType: disputeData?.dispute?.disputeType,
          },
        };
        store.commit(
          `${CHATMESSAGE}/updateDisputeChatMessageRoom`,
          disputePayload
        );

        if (route.name === "projectDetails" || route.name === "jobDetails") {
          store.dispatch(`${PROJECT_STORE}/getDisputeProject`, {
            projectRefId: route?.params?.refId,
          });
        }

        isDisputeAccepted.value = true;
      } else if (disputeData && disputeData.type === "reject-dispute-project") {
        const disputePayload = {
          id: props.userMessageRoomDetails.id,
          dispute: {
            ...props.userMessageRoomDetails.dispute,
            disputeType: disputeData?.dispute?.disputeType,
          },
        };
        store.commit(
          `${CHATMESSAGE}/updateDisputeChatMessageRoom`,
          disputePayload
        );

        isDisputeAccepted.value = false;
        hasCloseDisputeProposal.value = false;
        isImCloseDisputeRequestSender.value = false;
      }
    });
  subscribeDisputeProjectChannelList.value.push(roomChannel);
};
const getUserMessages = async (messageRoomId: number) => {
  try {
    loading.value = true;
    const messages = (await chatService.getUserMessages(messageRoomId)) as any;
    return messages;
  } catch (error) {
    console.log();
  } finally {
    loading.value = false;
  }
};

const scrollBottom = () => {
  nextTick(() => {
    const container = chatContainer.value;
    container.scrollTop = container.scrollHeight;
  });
};
const toggleCloseDisputeModal = () => {
  isShowCloseDisputeModal.value = !isShowCloseDisputeModal.value;
};
const viewOfferModal = (message: any) => {
  if (
    props.userMessageRoomDetails.chatType === ChatTypeEnum.DISPUTE_PROJECT &&
    isDisputeAccepted.value
  ) {
    // return;
  }

  let attachments = message.disputeOffer?.attachments;

  const isSender =
    messageChatUserClass(message) === "right_messages" ? true : false;
  attachments = attachments.map((attachment: any) => {
    return {
      publicURL: setDirectStoragePathToImage(attachment),
    };
  });
  selectedUserMessage.value = {
    statement: message.content,
    attachments,
    isSender,
    disputeOffer: message?.disputeOffer,
    messageId: message.id,
  };

  toggleViewOfferModal();
};
const toggleViewOfferModal = () => {
  isViewOfferModal.value = !isViewOfferModal.value;
};
const toggleCloseOfferDispute = () => {
  isShowOfferDisputeModal.value = !isShowOfferDisputeModal.value;
};

const submitDisputeOffer = async (data: any) => {
  inputNewMessage.value = data.userMessageContent;
  const disputeOfferId = data.disputeOffer.id;

  toggleCloseOfferDispute();

  const payload = {
    ...newMessagePayload.value,
    messageId: `${new Date().getTime()}`,
    content: inputNewMessage.value,
    disputeOfferId: disputeOfferId,
  };
  inputNewMessage.value = "";
  try {
    const disputePayload = {
      id: props.userMessageRoomDetails.id,
      dispute: {
        ...props.userMessageRoomDetails.dispute,
        dispute_offers: data?.disputeOffer ? [data?.disputeOffer] : [],
      },
    };
    store.commit(`${CHATMESSAGE}/updateDisputeChatMessageRoom`, disputePayload);

    hasPendingDisputeOffer.value = true;
    let responseMessage = (await chatService.createUserMessage(payload)) as any;
    if (!responseMessage) return;

    scrollBottom();

    userMessages.value.unshift(responseMessage);
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
    inputNewMessage.value = "";
    attachmentFile.value = null;
  }
};
const onAcceptOffer = (data: any) => {
  const msgId = data.messageId;

  userMessages.value = userMessages.value.map((msg: any) => {
    if (msg.id === msgId) {
      msg = {
        ...msg,
        disputeOffer: {
          ...msg.disputeOffer,
          status: DisputeRequestStatusEnums.ACCEPTED,
        },
      };
    }
    return msg;
  });

  isDisputeAccepted.value = true;
  toggleViewOfferModal();
};
const onRejectOffer = (data: any) => {
  const msgId = data.messageId;
  userMessages.value = userMessages.value.map((msg: any) => {
    if (msg.id === msgId) {
      msg = {
        ...msg,
        disputeOffer: {
          ...msg.disputeOffer,
          status: DisputeRequestStatusEnums.REJECTED,
        },
      };
    }
    return msg;
  });

  isDisputeAccepted.value = false;
  hasCloseDisputeProposal.value = false;
  isImCloseDisputeRequestSender.value = false;
  toggleViewOfferModal();
};
const onCloseDispute = () => {
  toggleCloseDisputeModal();
};

const onClickVideoCallButton = (msgId: number) => {
  if (!props.userMessageRoomDetails.isGroup) {
    emits(
      "onClickVideoCallButton",
      msgId,
      props.senderUserWorkstation.id,
      props.receiverUserWorkstation.id,
      null
    );
  } else {
    emits(
      "onClickVideoCallButton",
      msgId,
      props.senderUserWorkstation.id,
      null,
      props.userMessageRoomDetails?.parentId || props.userMessageRoomDetails?.id
    );
  }
};

const openFilePicker = () => {
  fileInputRef.value.click();
};
const appendMessageAttachment = async (event: any) => {
  const fileInput = event.target;

  if (fileInput.files && fileInput.files.length > 0) {
    const file = fileInput.files[0];
    attachmentImageUrl.value = URL.createObjectURL(file);
    attachmentFile.value = file;
  }
};

const groupAdminUser = computed(() =>
  groupsMemberDetails.value?.groupMembers.find(
    (member: any) => member?.isParent
  )
);

const isUserHasDeletePermission = computed(
  () =>
    activeUserWorkstation.value?.id ===
      groupAdminUser.value?.userWorkStation.id &&
    user.value.id === groupAdminUser.value?.user.id
);

const isDisputePending = computed(() => {
  return (
    disputeDetails.value &&
    disputeDetails.value?.dispute.close_proposal?.some(
      (proposal: any) => proposal?.status === "pending"
    )
  );
});

const isDisputeAccepted = ref(false);

const getUserGroupMembers = async (groupId: number) => {
  try {
    const response = (await chatService.getAllGroupMembers(groupId)) as any;
    disputeIssueId.value = response?.disputeIssueId;
    const adminUser = response?.groupMembers.find(
      (member: any) => member.isParent
    );

    const isExistUserInGroup = response?.groupMembers.find(
      (member: any) =>
        member.type === UserMessagesGroupTypeEnum.USER &&
        user.value.id === member?.user.id
    );
    if (isExistUserInGroup) {
      isGroupUserChat.value = true;
    } else isGroupUserChat.value = false;

    response.groupMembers = [
      adminUser,
      ...response?.groupMembers.filter((member: any) => !member.isParent),
    ];

    groupsMemberDetails.value = response;
    for (const member of groupsMemberDetails.value?.groupMembers) {
      if (member.user?.profileImage)
        emits("getUserWorkStationProfileImage", member.user?.profileImage);

      if (member.userWorkStation?.profileImage)
        emits(
          "getUserWorkStationProfileImage",
          member.userWorkStation.profileImage
        );
    }

    if (props.filterMessagesRooms && props.filterMessagesRooms.length) {
      disputeDetails.value = props.filterMessagesRooms.find(
        (room: any) =>
          room.dispute &&
          room.chatType === ChatTypeEnum.DISPUTE_PROJECT &&
          room.dispute.id === disputeIssueId.value
      );
    }
  } catch (error) {
    console.log("error", error);
  }
};

const onAcceptCloseDispute = async () => {
  if (props.userMessageRoomDetails.dispute) {
    try {
      const disputeRequestId = closeProposalData.value.id;

      const payload = {
        status: "accepted",
      };

      const request = {
        disputeRequestId,
        payload,
      };
      await store.dispatch(
        `${PROJECT_STORE}/updateCloseDisputeRequest`,
        request
      );
      displayToastMessage(
        internalInstance,
        "Accepted Dispute Project",
        "success"
      );
      isDisputeAccepted.value = true;
    } catch (error: any) {
      if (error.response) {
        if (error.response.status) {
          const errorMessage =
            error.response.data.message ||
            "An error occurred. Please try again.";
          displayToastMessage(internalInstance, errorMessage, "error");
        } else {
          // Handle other status codes or errors
          displayToastMessage(
            internalInstance,
            `Error: ${error.response.statusText}`,
            "error"
          );
        }
      } else {
        displayToastMessage(
          internalInstance,
          "The request took too long and timed out. Please try again later.",
          "error"
        );
      }
    }
  }
};

const onConfirmRejectCloseDispute = async () => {
  if (props.userMessageRoomDetails.dispute) {
    try {
      const disputeRequestId = closeProposalData.value.id;

      const payload = {
        status: "rejected",
      };

      const request = {
        disputeRequestId,
        payload,
      };

      await store.dispatch(
        `${PROJECT_STORE}/updateCloseDisputeRequest`,
        request
      );
      displayToastMessage(
        internalInstance,
        "rejected Dispute Project",
        "success"
      );

      isDisputeAccepted.value = false;
      hasCloseDisputeProposal.value = false;
      isImCloseDisputeRequestSender.value = false;
    } catch (error: any) {
      if (error.response) {
        if (error.response.status) {
          const errorMessage =
            error.response.data.message ||
            "An error occurred. Please try again.";
          displayToastMessage(internalInstance, errorMessage, "error");
        } else {
          // Handle other status codes or errors
          displayToastMessage(
            internalInstance,
            `Error: ${error.response.statusText}`,
            "error"
          );
        }
      } else {
        displayToastMessage(
          internalInstance,
          "The request took too long and timed out. Please try again later.",
          "error"
        );
      }
    } finally {
      onCloseRejectCloseDisputeModal();
    }
  }
};

const onAttachmentDiscard = () => {
  attachmentFile.value = null;
};

const deleteGroupMember = async (groupMemberId: number) => {
  try {
    groupsMemberDetails.value.groupMembers =
      groupsMemberDetails.value?.groupMembers.filter(
        (room: any) => room.id !== groupMemberId
      );

    await chatService.deleteGroupMember(groupMemberId);
  } catch (error) {
    console.log(error);
  }
};
const user = computed(() => store.getters[`${USER_STORE}/user`]);
const isProjectOwner = computed(() => {
  if (user.value?.role?.name === UserRolesEnum.PROPERTY_OWNER) {
    return true;
  }
  return false;
});

const isProjectChatCompleted = computed(() => {
  return (
    props.userMessageRoomDetails.projectStatus ===
      UserMessagesRoomStatusEnum.COMPLETED &&
    props.userMessageRoomDetails.project
  );
});

const onlineUser = computed(
  () => store.getters[`${WORKSTATION}/getUserOnlineWorkStations`]
);
const isUserWorkStationOnline = (wsId: number) => {
  const isExist = onlineUser.value?.find(
    (data: any) => data?.userWorkstations?.id === wsId
  );
  return isExist ? true : false;
};
const isUserOnline = (userId: number) => {
  return onlineUser.value?.find((user: any) => user.id == userId)
    ? true
    : false;
};

const isShowMediaList = ref(false);
const messageMediaList = ref([]) as any;
const onClickToggleMediaModal = () => {
  isShowMediaList.value = !isShowMediaList.value;
};

const setMessageMediaList = async () => {
  const updatedMessage = await Promise.all(
    userMessages.value.map(async (message: any) => ({
      date: moment(message.dateCreated).format("DD MMMM, YYYY"),
      mediaList: message?.userMessageRoom?.userMessageAttachments?.length
        ? await Promise.all(
            message?.userMessageRoom?.userMessageAttachments.map(
              async (attachment: any) => ({
                ...attachment,
                messageId: message.id,
                meta: attachment?.meta ? JSON.parse(attachment?.meta) : null,
                mediaUrl: await getImageStringToImageURL(
                  attachment?.attachment
                ),
              })
            )
          )
        : [],
    }))
  );
  const messageGroupByDate = updatedMessage.reduce(
    (newObj: any, message: any) => {
      if (!message.date) return newObj;
      if (newObj[message.date]) {
        newObj[message.date] = [...newObj[message.date], ...message.mediaList];
      } else {
        newObj[message.date] = message.mediaList;
      }
      return newObj;
    },
    {}
  );
  messageMediaList.value = Object.entries(messageGroupByDate).map(
    (message: any) => ({
      date: message[0],
      mediaList: message[1],
    })
  );
};
const isButtonDisabled = computed(() => {
  return (
    props.userMessageRoomDetails?.dispute?.disputeType ===
      DisputeTypeEnums.UNDER_REVIEW ||
    props.userMessageRoomDetails?.dispute?.disputeType ===
      DisputeTypeEnums.ADR_REVIEW ||
    props.userMessageRoomDetails?.dispute?.disputeType ===
      DisputeTypeEnums.CLOSED ||
    isDisputeAccepted.value
  );
});
const filterMediaList = computed(() =>
  !mediaSearch.value
    ? messageMediaList.value
    : messageMediaList.value.reduce((newArr: any, media: any) => {
        const filterMedia = media?.mediaList.filter((image: any) =>
          image.originalName
            .toLowerCase()
            .includes(mediaSearch.value.toLowerCase().trim())
        );
        if (filterMedia.length) {
          newArr.push({ ...media, mediaList: filterMedia });
        }
        return newArr;
      }, [])
);
const totalMediaCount = computed(() =>
  messageMediaList.value.reduce((mediaCount: any, media: any) => {
    mediaCount += media?.mediaList.length;
    return mediaCount;
  }, 0)
);

const filterMemberList = computed(() => {
  let memberList = groupsMemberDetails.value?.groupMembers;
  if (groupsMemberDetails.value?.isUserChat) {
    memberList = memberList.filter(
      (member: any) => member.type === UserMessagesGroupTypeEnum.USER
    );
  }

  return !memberSearching.value
    ? memberList
    : memberList?.filter((member: any) =>
        member?.userWorkStation?.name
          .toLowerCase()
          .includes(memberSearching.value.toLowerCase().trim())
      );
});

// const filterMessagesRooms = computed(
//   () => store.getters[`${CHATMESSAGE}/filterMessagesRooms`]
// );

const onShowMember = () => {
  isNewGroupMembers.value = !isNewGroupMembers.value;
  memberSearching.value = "";
};
const onShowAddNewMember = () => {
  selectedItems.value = [];
  isAddNewGroupMember.value = !isAddNewGroupMember.value;
  memberSearching.value = "";
};

const onCloseRejectCloseDisputeModal = () => {
  isShowConfirmRejectCloseDisputeModal.value = false;
};

const onOpenRejectCloseDisputeModal = () => {
  isShowConfirmRejectCloseDisputeModal.value = true;
};
const viewEvidenceModal = (message: any, attachemtId: any) => {
  const attachment = message?.userMessageRoom?.userMessageAttachments.find(
    (attachment: any) => {
      return attachment.id === attachemtId;
    }
  );
  if (attachment) {
    attachment.publicURL = setDirectStoragePathToImage(attachment.attachment);
  } else {
    console.log("Attachment not found");
  }

  selectedUserMessage.value = {
    evidenceData: attachment,
  };

  toggleViewEvidenceModal();
};

watch(
  () => props.userAllMessages,
  async (value: any) => {
    if (value && value.length) {
      let latestMessages = props.userAllMessages.map((msg: any) => {
        if (
          props.userMessageRoomDetails.chatType === ChatTypeEnum.DISPUTE_PROJECT
        ) {
          if (msg?.disputeOffer && msg?.disputeOffer?.status === "pending") {
            hasPendingDisputeOffer.value = true;

            const disputePayload = {
              id: props.userMessageRoomDetails.id,
              dispute: {
                ...props.userMessageRoomDetails.dispute,
                dispute_offers: msg?.disputeOffer ? [msg?.disputeOffer] : [],
              },
            };
            store.commit(
              `${CHATMESSAGE}/updateDisputeChatMessageRoom`,
              disputePayload
            );
          }
        }

        return {
          ...msg,
          unReadMsg: 0,
        };
      });
      latestMessages = latestMessages.filter((msg: any) => {
        const isExits = userMessages.value.find(
          (data: any) => data.id === msg?.id
        );
        if (!isExits) return true;
      });
      userMessages.value = [...latestMessages, ...userMessages.value];
      scrollBottom();
    }
  },

  { immediate: true, deep: true }
);

// const disputeDetails = computed(() => {
//   return filterMessagesRooms.value.find(
//     (room: any) =>
//       room.dispute &&
//       room.chatType === "dispute_project" &&
//       room.dispute.id === disputeIssueId.value
//   );
// });
// const isCloseRequestPending = computed(() => {
//   const disputeDetails =
// });
onMounted(() => {
  if (props.userMessageRoomDetails.isGroup) {
    subscribeGroupMessage();
  }
  if (props.userMessageRoomDetails.chatType === ChatTypeEnum.DISPUTE_PROJECT) {
    subscribeDisputeProjectRequest();
  }
});

const countLines = (description: string) => {
  let words = description?.trim().split(" ");
  let maxLength = window.innerWidth < 720 ? 10 : 18;

  if (words?.length > maxLength) {
    return true;
  }

  return false;
};

const onClickToggleShowText = (itemId: number) => {
  if (toggleShowText.value === itemId) {
    toggleShowText.value = null;
  } else {
    toggleShowText.value = itemId;
  }
};

const onConfirmCloseDispute = async () => {
  if (props.userMessageRoomDetails.dispute?.id) {
    try {
      const response = await store.dispatch(
        `${PROJECT_STORE}/closeDisputeProject`,
        {
          disputeIssueId: props.userMessageRoomDetails.dispute?.id,
        }
      );
      closeProposalData.value = response?.data;
      const disputePayload = {
        id: props.userMessageRoomDetails.id,
        dispute: {
          ...props.userMessageRoomDetails.dispute,
          close_proposal: response?.data ? [response?.data] : [],
        },
      };
      store.commit(
        `${CHATMESSAGE}/updateDisputeChatMessageRoom`,
        disputePayload
      );

      hasCloseDisputeProposal.value = true;
      isImCloseDisputeRequestSender.value =
        response?.data?.userWorkstation.id === activeUserWorkstation?.value.id;
    } catch (error: any) {
      if (error.response) {
        if (error.response.status) {
          const errorMessage =
            error.response.data.message ||
            "An error occurred. Please try again.";
          displayToastMessage(internalInstance, errorMessage, "error");
        } else {
          // Handle other status codes or errors
          displayToastMessage(
            internalInstance,
            `Error: ${error.response.statusText}`,
            "error"
          );
        }
      } else {
        displayToastMessage(
          internalInstance,
          "The request took too long and timed out. Please try again later.",
          "error"
        );
      }
    } finally {
      onCloseDispute();
    }
  } else {
    displayToastMessage(internalInstance, `Something went wrong`, "error");
  }
};

const messageChatUserClass = (message: any) => {
  return message?.userMessageRoom?.isUserChat
    ? user.value?.id === message?.fromUser?.id
      ? "right_messages"
      : "left_messages"
    : activeUserWorkstation?.value.id == message?.fromWorkstationId?.id
    ? "right_messages"
    : "left_messages";
};
onBeforeUnmount(() => {
  unbindSubscribeGroupChannelList();
  unbindSubscribeDisputeProject();
});

onBeforeMount(async () => {
  let messageRoomId = props.userMessageRoomDetails?.id;
  const getAllMessages = await getUserMessages(messageRoomId);
  userMessages.value = getAllMessages?.map((msg: any) => {
    return {
      ...msg,
      unReadMsg: 0,
    };
  });

  const unreadMessagesCount = props.userMessageRoomDetails?.unReadMessageCount;
  if (unreadMessagesCount) {
    const total = userMessages.value.length;
    userMessages.value[unreadMessagesCount - 1].unReadMsg = unreadMessagesCount;
  }

  if (props.userMessageRoomDetails && props.userMessageRoomDetails.isGroup) {
    closeProposalData.value =
      props.userMessageRoomDetails.dispute?.close_proposal[0];

    isDisputeAccepted.value =
      props.userMessageRoomDetails.dispute?.disputeType === "closed"
        ? true
        : false;

    const hasDisputeOffer =
      props.userMessageRoomDetails?.dispute?.dispute_offers?.some(
        (offer: any) => offer?.status === "pending"
      );
    hasPendingDisputeOffer.value = hasDisputeOffer ? true : false;

    const hasCloseDispute =
      props.userMessageRoomDetails?.dispute?.close_proposal?.some(
        (offer: any) => {
          return offer?.status === "pending";
        }
      );
    hasCloseDisputeProposal.value = hasCloseDispute ? true : false;

    hasDisputeRaise.value =
      props.userMessageRoomDetails?.dispute?.disputeType ===
      DisputeTypeEnums.RAISED
        ? true
        : false;

    const isImCloseDisputeRequest =
      props.userMessageRoomDetails?.dispute?.close_proposal?.some(
        (offer: any) => {
          return offer?.userWorkstation.id === activeUserWorkstation?.value.id;
        }
      );
    isImCloseDisputeRequestSender.value = isImCloseDisputeRequest
      ? true
      : false;

    try {
      isLoading.value = true;
      const groupId = props.userMessageRoomDetails.id;
      await getUserGroupMembers(groupId);
    } catch (error) {
      console.log(error);
    } finally {
      isLoading.value = false;
    }
  }

  setMessageMediaList();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_card = _resolveComponent("v-card")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["messagechat__wrapper", { messagechat__active: isShowMessage.value }])
    }, [
      _createVNode(_component_v_card, {
        class: "messagechat__inner",
        variant: "flat"
      }, _createSlots({ _: 2 }, [
        (!isNewGroupMembers.value && !isShowMediaList.value)
          ? {
              name: "text",
              fn: _withCtx(() => [
                _createElementVNode("div", {
                  class: "messagechat__top",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleMessages()))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["messagechat__left", { 'with-group': __props.userMessageRoomDetails?.isGroup }])
                  }, [
                    _createElementVNode("div", _hoisted_1, [
                      (
                  (isProjectOwner.value && !__props.userMessageRoomDetails?.isUserChat) ||
                  __props.userMessageRoomDetails?.project
                )
                        ? (_openBlock(), _createBlock(UserProfileLogo, {
                            key: 0,
                            userName: __props.userMessageRoomDetails?.groupName
                          }, null, 8, ["userName"]))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            loading: "lazy",
                            src: 
                  !__props.userMessageRoomDetails?.isGroup
                    ? getImagePublicUrl(
                        __props.userMessageRoomDetails?.isUserChat
                          ? __props.receiverUserWorkstation?.user?.profileImage
                          : __props.receiverUserWorkstation?.profileImage
                      )
                    : getImagePublicUrl(__props.userMessageRoomDetails?.groupAvatar)
                    ? getImagePublicUrl(__props.userMessageRoomDetails?.groupAvatar)
                    : require('@/assets/images/user-placeholder.png')
                ,
                            alt: "chat_box_icon"
                          }, null, 8, _hoisted_2)),
                      (!__props.userMessageRoomDetails?.isGroup)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: _normalizeClass(
                  (
                    __props.userMessageRoomDetails?.isUserChat
                      ? isUserOnline(__props.receiverUserWorkstation?.user?.id)
                      : isUserWorkStationOnline(__props.receiverUserWorkstation?.id)
                  )
                    ? 'online'
                    : 'offline'
                )
                          }, null, 2))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("h5", null, _toDisplayString(__props.userMessageRoomDetails?.isGroup
                      ? __props.userMessageRoomDetails?.groupName
                      : !__props.receiverUserWorkstation?.isUserChat
                      ? __props.receiverUserWorkstation?.name
                      : __props.receiverUserWorkstation?.user?.firstName +
                        " " +
                        __props.receiverUserWorkstation?.user?.lastName), 1),
                        (
                    !__props.userMessageRoomDetails?.isGroup &&
                    !__props.userMessageRoomDetails?.isUserChat
                  )
                          ? (_openBlock(), _createElementBlock("p", _hoisted_5, " ( " + _toDisplayString(__props.receiverUserWorkstation?.user?.firstName +
                    " " +
                    __props.receiverUserWorkstation?.user?.lastName) + " ) ", 1))
                          : _createCommentVNode("", true)
                      ]),
                      (isShowMessage.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            (__props.userMessageRoomDetails?.isGroup)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass(
                    isButtonDisabled.value
                      ? 'tw-opacity-50 tw-pointer-events-none'
                      : ''
                  )
                                }, _toDisplayString(groupsMemberDetails.value?.groupMembers?.length), 3))
                              : _createCommentVNode("", true),
                            (__props.userMessageRoomDetails?.isGroup)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  onClick: _withModifiers(onShowMember, ["stop"]),
                                  class: _normalizeClass(
                    isButtonDisabled.value
                      ? 'tw-opacity-50 tw-pointer-events-none'
                      : ''
                  )
                                }, " Members ", 2))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (!__props.userMessageRoomDetails?.isGroup)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString((
                    !__props.userMessageRoomDetails?.isUserChat
                      ? isUserWorkStationOnline(__props.receiverUserWorkstation?.id)
                      : isUserOnline(__props.receiverUserWorkstation?.user?.id)
                  )
                    ? "Active now"
                    : "Offline"), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 2),
                  _createElementVNode("div", _hoisted_8, [
                    (isShowMessage.value)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          class: "video-call-image",
                          diabled: isButtonDisabled.value,
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (onClickVideoCallButton(__props.userMessageRoomDetails?.id)))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: require('@/assets/icons/camera.svg'),
                              alt: "",
                              diabled: isButtonDisabled.value,
                              class: _normalizeClass(
                  isButtonDisabled.value ? 'tw-opacity-50 tw-pointer-events-none' : ''
                )
                            }, null, 10, _hoisted_9)
                          ]),
                          _: 1
                        }, 8, ["diabled"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_icon, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (closeMessageBox(__props.userMessageRoomDetails?.id)))
                    }),
                    (isShowMessage.value)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          onClick: onClickToggleMediaModal,
                          class: "chat_image_display",
                          variant: "plain",
                          height: "auto"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_icon, {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (closeMessageBox(__props.userMessageRoomDetails?.id))),
                      class: "close_icon"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: require('@/assets/icons/cancel.svg'),
                          alt: ""
                        }, null, 8, _hoisted_11)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                (!loading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (__props.userMessageRoomDetails?.isArchiveRoom)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(["messagechat__bottom no-scrollbar", {
              isFileAttached: attachmentFile.value,
              '!tw-mt-[4.2rem]':
                __props.userMessageRoomDetails.chatType ===
                  _unref(ChatTypeEnum).DISPUTE_PROJECT && !isDisputeAccepted.value,
              '!tw-mt-[6.5rem]':
                __props.userMessageRoomDetails.chatType ===
                  _unref(ChatTypeEnum).DISPUTE_PROJECT && isDisputeAccepted.value,
            }]),
                        ref_key: "chatContainer",
                        ref: chatContainer
                      }, [
                        (
                !userMessages.value?.length &&
                __props.userMessageRoomDetails.chatType ===
                  _unref(ChatTypeEnum).DISPUTE_PROJECT &&
                !isDisputeAccepted.value
              )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19))
                          : _createCommentVNode("", true),
                        (
                __props.userMessageRoomDetails.chatType ===
                  _unref(ChatTypeEnum).DISPUTE_PROJECT && isDisputeAccepted.value
              )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, [
                                _createVNode(Text, { variant: "p" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" CASE CLOSED! ")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (
                __props.userMessageRoomDetails.chatType ===
                  _unref(ChatTypeEnum).DISPUTE_PROJECT && isDisputeAccepted.value
              )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                _createVNode(InfoIcon, { class: "tw-min-w-[14.67px] tw-w-[14.67px] tw-h-[14.67px]" }),
                                _createVNode(Text, {
                                  variant: "p",
                                  lineHeight: "18px",
                                  textAlign: "left"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Congratulations! Your dispute was successfully resolved during the Early Reconciliation Phase. The case is now closed.")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (
                __props.userMessageRoomDetails.chatType ===
                  _unref(ChatTypeEnum).DISPUTE_PROJECT &&
                __props.userMessageRoomDetails.dispute?.disputeType ===
                  _unref(DisputeTypeEnums).UNDER_REVIEW
              )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _createVNode(InfoIcon, { class: "tw-min-w-[14.67px] tw-w-[14.67px] tw-h-[14.67px]" }),
                                _createVNode(Text, {
                                  variant: "p",
                                  lineHeight: "18px",
                                  textAlign: "left"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Your dispute has been escalated to the iknowa Review Team. Please allow up to 7 working days for the decision, depending on case complexity..")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (
                __props.userMessageRoomDetails.chatType ===
                  _unref(ChatTypeEnum).DISPUTE_PROJECT &&
                __props.userMessageRoomDetails.dispute?.disputeType ===
                  _unref(DisputeTypeEnums).ADR_REVIEW
              )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _createVNode(InfoIcon, { class: "tw-min-w-[14.67px] tw-w-[14.67px] tw-h-[14.67px]" }),
                                _createVNode(Text, {
                                  variant: "p",
                                  lineHeight: "18px",
                                  textAlign: "left"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("The ADR team has reviewed your dispute and issued a legally binding decision. View the decision summary and award details in your dashboard.")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (
                hasDisputeRaise.value &&
                __props.userMessageRoomDetails.chatType ===
                  _unref(ChatTypeEnum).DISPUTE_PROJECT &&
                !isDisputeAccepted.value
              )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              (
                  !hasCloseDisputeProposal.value ||
                  (hasCloseDisputeProposal.value && isImCloseDisputeRequestSender.value)
                )
                                ? (_openBlock(), _createBlock(Button, {
                                    key: 0,
                                    onClick: onCloseDispute,
                                    variant: "accent",
                                    label: 
                  isImCloseDisputeRequestSender.value
                    ? 'Request Close Dispute'
                    : 'Close dispute'
                ,
                                    isCapitalize: true,
                                    isActive: !hasCloseDisputeProposal.value,
                                    class: "!tw-w-[calc(100%-9.1rem)]"
                                  }, null, 8, ["label", "isActive"]))
                                : _createCommentVNode("", true),
                              (
                  !hasCloseDisputeProposal.value ||
                  (hasCloseDisputeProposal.value && isImCloseDisputeRequestSender.value)
                )
                                ? (_openBlock(), _createBlock(Button, {
                                    key: 1,
                                    onClick: toggleCloseOfferDispute,
                                    variant: "secondary",
                                    label: "Make An Offer",
                                    isActive: !hasPendingDisputeOffer.value,
                                    class: "!tw-w-auto",
                                    isCapitalize: true
                                  }, null, 8, ["isActive"]))
                                : _createCommentVNode("", true),
                              (hasCloseDisputeProposal.value && !isImCloseDisputeRequestSender.value)
                                ? (_openBlock(), _createBlock(Button, {
                                    key: 2,
                                    onClick: onAcceptCloseDispute,
                                    variant: "accent",
                                    label: "Accept Close Dispute",
                                    isCapitalize: true,
                                    disabled: isDisputePending.value && isImCloseDisputeRequestSender.value,
                                    class: "!tw-w-[calc(100%-11.8rem)]"
                                  }, null, 8, ["disabled"]))
                                : _createCommentVNode("", true),
                              (hasCloseDisputeProposal.value && !isImCloseDisputeRequestSender.value)
                                ? (_openBlock(), _createBlock(Button, {
                                    key: 3,
                                    onClick: onOpenRejectCloseDisputeModal,
                                    variant: "secondary",
                                    label: "Reject close Dispute",
                                    disabled: isDisputePending.value && isImCloseDisputeRequestSender.value,
                                    class: "!tw-w-auto",
                                    isCapitalize: true
                                  }, null, 8, ["disabled"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userMessages.value, (message, index) => {
                          return _withDirectives((_openBlock(), _createElementBlock("div", {
                            class: "messagechat__bottom__chats",
                            key: message.id
                          }, [
                            (
                  message.content
                    ? true
                    : message.userMessageRoom.userMessageAttachments &&
                      message.userMessageRoom.userMessageAttachments.length
                    ? true
                    : false
                )
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(messageChatUserClass(message))
                                }, [
                                  (shouldDisplayDate(message, index))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                        _createElementVNode("p", null, _toDisplayString(getTheDay(message.dateCreated)), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (message?.unReadMsg)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                        _createElementVNode("p", null, _toDisplayString(message?.unReadMsg) + " Unread Message", 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("div", _hoisted_32, [
                                      _createElementVNode("div", _hoisted_33, [
                                        _createElementVNode("img", {
                                          src: 
                          getImagePublicUrl(
                            __props.userMessageRoomDetails?.isUserChat ||
                              isGroupUserChat.value
                              ? message?.fromUser?.profileImage
                              : message?.fromWorkstationId?.profileImage
                          )
                            ? getImagePublicUrl(
                                __props.userMessageRoomDetails?.isUserChat ||
                                  isGroupUserChat.value
                                  ? message?.fromUser?.profileImage
                                  : message?.fromWorkstationId?.profileImage
                              )
                            : require('@/assets/images/user-placeholder.png')
                        ,
                                          alt: "workstation_img"
                                        }, null, 8, _hoisted_34),
                                        _createElementVNode("div", {
                                          class: _normalizeClass(
                          (
                            __props.userMessageRoomDetails?.isUserChat
                              ? isUserOnline(message?.fromUser?.id)
                              : isUserWorkStationOnline(
                                  message?.fromWorkstationId?.id
                                )
                          )
                            ? 'online'
                            : 'offline'
                        )
                                        }, null, 2)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_35, [
                                      _createElementVNode("div", _hoisted_36, [
                                        _createElementVNode("h6", null, _toDisplayString(message?.userMessageRoom?.isUserChat ||
                          isGroupUserChat.value
                            ? message?.fromUser?.firstName +
                              " " +
                              message?.fromUser?.lastName
                            : message?.fromWorkstationId?.name), 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_37, [
                                      _createElementVNode("span", null, _toDisplayString(getTimeElapsedString(message.dateCreated)), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["messagechat__bottom__chats__text", { 'toggle-text': toggleShowText.value === message.id }])
                                  }, [
                                    _createElementVNode("p", null, [
                                      _createVNode(Text, {
                                        variant: "span",
                                        textWeight: "400",
                                        textColor: "rgba(12, 15, 74, 0.94)"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(message.content), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    (
                      __props.userMessageRoomDetails.chatType ===
                        _unref(ChatTypeEnum).DISPUTE_PROJECT &&
                      message?.disputeOffer?.id
                    )
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          onClick: ($event: any) => (viewOfferModal(message)),
                                          class: "chip__wrapper"
                                        }, _hoisted_40, 8, _hoisted_38))
                                      : _createCommentVNode("", true),
                                    (countLines(message?.content))
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 1,
                                          class: "message-toggle",
                                          onClick: ($event: any) => (onClickToggleShowText(message.id))
                                        }, _toDisplayString(toggleShowText.value === message.id ? "Show Less" : "Read More"), 9, _hoisted_41))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.userMessageRoom
                      .userMessageAttachments, (data) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "messagechat_attachment_wrapper",
                                        key: data.id
                                      }, [
                                        _createElementVNode("div", _hoisted_42, [
                                          _createElementVNode("div", _hoisted_43, [
                                            _createElementVNode("div", _hoisted_44, [
                                              _createElementVNode("img", {
                                                style: {"height":"20px"},
                                                src: require('@/assets/icons/documents.svg'),
                                                alt: ""
                                              }, null, 8, _hoisted_45)
                                            ]),
                                            _hoisted_46
                                          ]),
                                          _createElementVNode("span", _hoisted_47, [
                                            (
                            data.id &&
                            !attachmentDownloadLoadingArray.value.includes(data.id)
                          )
                                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                                  key: 0,
                                                  onClick: ($event: any) => (downloadAttachment(data)),
                                                  class: "download__icon"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("img", {
                                                      style: {"height":"20px"},
                                                      src: require('@/assets/icons/downloads.svg'),
                                                      alt: ""
                                                    }, null, 8, _hoisted_48)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"]))
                                              : _createCommentVNode("", true),
                                            (
                            attachmentDownloadLoadingArray.value.includes(data.id)
                          )
                                              ? (_openBlock(), _createBlock(CommonLoader, {
                                                  key: 1,
                                                  class: "chat_loader",
                                                  loading: 
                            attachmentDownloadLoadingArray.value.includes(data.id)
                          
                                                }, null, 8, ["loading"]))
                                              : _createCommentVNode("", true),
                                            (isLoading.value && isShowMessage.value)
                                              ? (_openBlock(), _createBlock(CommonLoader, {
                                                  key: 2,
                                                  class: "chat_loader",
                                                  loading: isLoading.value && !data.id
                                                }, null, 8, ["loading"]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        (
                        __props.userMessageRoomDetails?.chatType ===
                        _unref(ChatTypeEnum).DISPUTE_PROJECT
                      )
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              onClick: ($event: any) => (viewEvidenceModal(message, data?.id)),
                                              class: "chip__wrapper"
                                            }, _hoisted_51, 8, _hoisted_49))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  ], 2)
                                ], 2))
                              : _createCommentVNode("", true)
                          ])), [
                            [_directive_click_outside, closeEmojiPicker]
                          ])
                        }), 128))
                      ], 2),
                      (!isProjectChatCompleted.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(["messagechat__input", { isAttached: attachmentFile.value }]),
                            id: "click-outside"
                          }, [
                            (attachmentFile.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                  _createElementVNode("div", _hoisted_53, [
                                    (attachmentImageUrl.value)
                                      ? (_openBlock(), _createBlock(_component_v_img, {
                                          key: 0,
                                          class: "uploaded-img",
                                          width: 200,
                                          "aspect-ratio": "16/9",
                                          cover: "",
                                          src: attachmentImageUrl.value
                                        }, null, 8, ["src"]))
                                      : (_openBlock(), _createElementBlock("img", {
                                          key: 1,
                                          src: require('@/assets/icons/chat-dox.svg'),
                                          alt: ""
                                        }, null, 8, _hoisted_54))
                                  ]),
                                  _createVNode(_component_v_icon, {
                                    class: "cancel-icon",
                                    onClick: onAttachmentDiscard
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_55
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true),
                            (isCompleteChat.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_56, _hoisted_58))
                              : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                  _createElementVNode("div", _hoisted_60, [
                                    _createVNode(_component_v_icon, {
                                      icon: "mdi mdi-attachment",
                                      onClick: openFilePicker,
                                      disabled: isButtonDisabled.value
                                    }, null, 8, ["disabled"]),
                                    _createVNode(_component_v_icon, {
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (isEmojiKeyboard.value = !isEmojiKeyboard.value)),
                                      disabled: isButtonDisabled.value,
                                      icon: "mdi mdi-emoticon-happy-outline",
                                      class: "tw-cursor-pointer"
                                    }, null, 8, ["disabled"])
                                  ]),
                                  _createVNode(_component_v_textarea, {
                                    "bg-color": "white",
                                    "base-color": "white",
                                    density: "compact",
                                    variant: "solo",
                                    flat: "",
                                    placeholder: "Reply",
                                    "no-resize": "",
                                    rows: "1",
                                    "auto-grow": "",
                                    modelValue: inputNewMessage.value,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((inputNewMessage).value = $event)),
                                    "max-rows": "8",
                                    onKeydown: _cache[7] || (_cache[7] = _withKeys(($event: any) => (saveNewMessage(true, $event)), ["enter"])),
                                    disabled: isButtonDisabled.value
                                  }, {
                                    "append-inner": _withCtx(() => [
                                      (
                      __props.userMessageRoomDetails.chatType ===
                        _unref(ChatTypeEnum).DISPUTE_PROJECT && !isDisputeAccepted.value
                    )
                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 0,
                                            icon: "mdi-chevron-right-circle",
                                            onClick: _cache[5] || (_cache[5] = ($event: any) => (saveNewMessage(false, null)))
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "disabled"]),
                                  _createVNode(_component_v_file_input, {
                                    disabled: 
                  isLoading.value ||
                  (__props.userMessageRoomDetails.chatType ===
                    _unref(ChatTypeEnum).DISPUTE_PROJECT &&
                    isDisputeAccepted.value)
                ,
                                    ref_key: "fileInputRef",
                                    ref: fileInputRef,
                                    modelValue: attachmentFile.value,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((attachmentFile).value = $event)),
                                    accept: "image/*",
                                    style: {"display":"none"},
                                    onChange: appendMessageAttachment
                                  }, null, 8, ["disabled", "modelValue"])
                                ])),
                            _createElementVNode("div", _hoisted_61, [
                              (isEmojiKeyboard.value)
                                ? (_openBlock(), _createBlock(_unref(EmojiPicker), {
                                    key: 0,
                                    native: true,
                                    "display-recent": true,
                                    onSelect: onSelectEmoji
                                  }))
                                : _createCommentVNode("", true)
                            ])
                          ], 2))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(CommonLoader, { loading: loading.value }, null, 8, ["loading"])
              ]),
              key: "0"
            }
          : (isNewGroupMembers.value && !isShowMediaList.value)
            ? {
                name: "text",
                fn: _withCtx(() => [
                  _createElementVNode("div", { class: "header" }, [
                    _createElementVNode("div", { class: "left__block" }, [
                      (__props.userMessageRoomDetails?.isGroup)
                        ? (_openBlock(), _createElementBlock("span", { key: 0 }, _toDisplayString(groupsMemberDetails.value?.groupMembers?.length), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", {
                        onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (isNewGroupMembers.value = !isNewGroupMembers.value), ["stop"]))
                      }, "Members")
                    ]),
                    _createVNode(_component_v_icon, {
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (closeNewGroupModal())),
                      class: "close_icon"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: require('@/assets/icons/cancel.svg'),
                          alt: ""
                        }, null, 8, ["src"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", { class: "members__search" }, [
                    _createVNode(_component_v_text_field, {
                      "model-value": memberSearching.value,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((memberSearching).value = $event)),
                      class: "chatbox__search",
                      "prepend-inner-icon": "mdi-magnify",
                      variant: "solo-filled",
                      "hide-details": "",
                      "single-line": "",
                      flat: "",
                      placeholder: "Search"
                    }, null, 8, ["model-value"])
                  ]),
                  (!isAddNewGroupMember.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "group__members"
                      }, [
                        _createElementVNode("div", { class: "group__contact__members" }, [
                          (isUserHasDeletePermission.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "group__add__members",
                                onClick: onShowAddNewMember
                              }, [
                                _createElementVNode("div", { class: "add__members__icon" }, [
                                  _createVNode(_component_v_icon, { icon: "mdi-account-group" })
                                ]),
                                _createElementVNode("p", null, "Add New Member")
                              ]))
                            : _createCommentVNode("", true),
                          (filterMemberList.value?.length)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "group__members__list"
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterMemberList.value, (contact) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "group_members",
                                    key: contact?.id
                                  }, [
                                    _createElementVNode("div", { class: "group__contact_details" }, [
                                      _createElementVNode("div", { class: "group__members__img" }, [
                                        _createElementVNode("img", {
                                          loading: "lazy",
                                          src: 
                        getImagePublicUrl(
                          contact?.type === _unref(UserMessagesGroupTypeEnum).USER
                            ? contact?.user?.profileImage
                            : contact?.userWorkStation?.profileImage
                        )
                          ? getImagePublicUrl(
                              contact?.type === _unref(UserMessagesGroupTypeEnum).USER
                                ? contact?.user?.profileImage
                                : contact?.userWorkStation?.profileImage
                            )
                          : require('@/assets/images/user-placeholder.png')
                      
                                        }, null, 8, ["src"])
                                      ]),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(
                      (
                        __props.userMessageRoomDetails?.isUserChat
                          ? isUserOnline(contact?.user?.id)
                          : isUserWorkStationOnline(
                              contact?.userWorkStation?.id
                            )
                      )
                        ? 'online'
                        : 'offline'
                    )
                                      }, null, 2),
                                      _createElementVNode("p", null, _toDisplayString(contact?.type === _unref(UserMessagesGroupTypeEnum).USER
                        ? contact?.user?.firstName +
                          " " +
                          contact?.user?.lastName
                        : contact?.userWorkStation?.name), 1)
                                    ]),
                                    (contact?.isParent)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "admin"
                                        }, [
                                          _createElementVNode("span", null, "admin")
                                        ]))
                                      : _createCommentVNode("", true),
                                    (!contact.isParent && isUserHasDeletePermission.value)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          class: "delete"
                                        }, [
                                          _createElementVNode("span", {
                                            onClick: ($event: any) => (deleteGroupMember(contact?.id))
                                          }, "delete", 8, ["onClick"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "group__new__members"
                      }, [
                        _createElementVNode("div", { class: "group_selector" }, [
                          _createVNode(_component_v_list, { dense: "" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", { class: "group__members__list" }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterMemberList.value, (contact) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "group_members",
                                    key: contact?.id
                                  }, [
                                    _createElementVNode("div", { class: "group__contact_details" }, [
                                      _createElementVNode("div", { class: "group__members__img" }, [
                                        _createElementVNode("img", {
                                          loading: "lazy",
                                          src: 
                          getImagePublicUrl(
                            contact?.type === _unref(UserMessagesGroupTypeEnum).USER
                              ? contact?.user?.profileImage
                              : contact?.userWorkStation?.profileImage
                          )
                            ? getImagePublicUrl(
                                contact?.type === _unref(UserMessagesGroupTypeEnum).USER
                                  ? contact?.user?.profileImage
                                  : contact?.userWorkStation?.profileImage
                              )
                            : require('@/assets/images/user-placeholder.png')
                        
                                        }, null, 8, ["src"])
                                      ]),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(
                        (
                          __props.userMessageRoomDetails?.isUserChat
                            ? isUserOnline(contact?.user?.id)
                            : isUserWorkStationOnline(
                                contact?.userWorkStation?.id
                              )
                        )
                          ? 'online'
                          : 'offline'
                      )
                                      }, null, 2),
                                      _createElementVNode("p", null, _toDisplayString(contact?.type === _unref(UserMessagesGroupTypeEnum).USER
                          ? contact?.user?.firstName +
                            " " +
                            contact?.user?.lastName
                          : contact?.userWorkStation?.name), 1)
                                    ]),
                                    (contact.isParent)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "admin"
                                        }, [
                                          _createElementVNode("span", null, "admin")
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          class: "add"
                                        }, [
                                          _createElementVNode("span", null, "added")
                                        ]))
                                  ]))
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterGroupNetWorkContactList.value, (contact) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "group_members",
                                    key: contact?.id
                                  }, [
                                    _createElementVNode("div", { class: "group__contact_details" }, [
                                      _createElementVNode("div", { class: "group__members__img" }, [
                                        _createElementVNode("img", {
                                          loading: "lazy",
                                          src: 
                          getImagePublicUrl(
                            contact?.isUserChat
                              ? contact?.receiverWorkstation.user?.profileImage
                              : contact?.receiverWorkstation?.profileImage
                          )
                            ? getImagePublicUrl(
                                contact?.isUserChat
                                  ? contact?.receiverWorkstation.user
                                      ?.profileImage
                                  : contact?.receiverWorkstation?.profileImage
                              )
                            : require('@/assets/images/user-placeholder.png')
                        
                                        }, null, 8, ["src"])
                                      ]),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(
                        (
                          __props.userMessageRoomDetails?.isUserChat
                            ? isUserOnline(
                                contact?.receiverWorkstation.user?.id
                              )
                            : isUserWorkStationOnline(
                                contact?.receiverWorkstation?.id
                              )
                        )
                          ? 'online'
                          : 'offline'
                      )
                                      }, null, 2),
                                      _createElementVNode("p", null, _toDisplayString(contact?.isUserChat
                          ? contact?.receiverWorkstation?.user.firstName +
                            " " +
                            contact?.receiverWorkstation?.user.lastName
                          : contact?.receiverWorkstation?.name), 1)
                                    ]),
                                    _createElementVNode("div", {
                                      onClick: ($event: any) => (updateSelectedItems(contact)),
                                      class: "add"
                                    }, [
                                      (isAddedContact(contact))
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 0,
                                            class: "cursor-pointer"
                                          }, "add"))
                                        : (_openBlock(), _createElementBlock("span", {
                                            key: 1,
                                            class: "cursor-pointer"
                                          }, "added"))
                                    ], 8, ["onClick"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", { class: "submit_button" }, [
                            _createVNode(_component_v_btn, {
                              onClick: onShowAddNewMember,
                              class: "button button-purple-border",
                              width: "auto"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" cancel ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_btn, {
                              width: "auto",
                              class: "button button-orange",
                              disabled: !selectedItems.value.length,
                              onClick: addNewGroupMembers
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" save ")
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ])
                        ])
                      ]))
                ]),
                key: "1"
              }
            : (isShowMediaList.value)
              ? {
                  name: "text",
                  fn: _withCtx(() => [
                    _createElementVNode("div", { class: "media-modal" }, [
                      _createElementVNode("div", { class: "header" }, [
                        _createVNode(_component_v_icon, {
                          icon: "mdi-chevron-left",
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (onClickToggleMediaModal()))
                        }),
                        _createElementVNode("h4", null, "Media " + _toDisplayString(totalMediaCount.value || 0), 1),
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: _imports_2,
                              alt: "",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (onClickToggleMediaModal()))
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", { class: "media-modal__inner" }, [
                        _createElementVNode("div", { class: "members__search" }, [
                          _createVNode(_component_v_text_field, {
                            "model-value": mediaSearch.value,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((mediaSearch).value = $event)),
                            class: "chatbox__search",
                            "prepend-inner-icon": "mdi-magnify",
                            variant: "solo-filled",
                            flat: "",
                            placeholder: "Search"
                          }, null, 8, ["model-value"])
                        ]),
                        _createVNode(CommonLoader, {
                          class: "chat_loader",
                          loading: isLoading.value
                        }, null, 8, ["loading"]),
                        (
                !isLoading.value &&
                (filterMediaList.value?.length == 0 ||
                  filterMediaList.value?.[0].mediaList.length == 0)
              )
                          ? (_openBlock(), _createElementBlock("p", { key: 0 }, " No Data Available "))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", { class: "media-modal__group-wrapper" }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterMediaList.value, (message) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "media-modal__group",
                              key: message.date
                            }, [
                              (message.mediaList.length > 0)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "media-modal__group-date"
                                  }, [
                                    _createElementVNode("p", null, _toDisplayString(message.date), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", { class: "media-modal__group-inner" }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.mediaList, (media) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "media-modal__item",
                                    key: media.id
                                  }, [
                                    _createVNode(_component_v_menu, {
                                      "close-on-content-click": false,
                                      location: "end",
                                      origin: "auto",
                                      "scroll-strategy": "close",
                                      class: "dropdown_editor"
                                    }, {
                                      activator: _withCtx(({ props }) => [
                                        _createElementVNode("div", _mergeProps({ ref_for: true }, props, { class: "media-modal__item-menu-icon" }), [
                                          _createElementVNode("img", {
                                            src: _imports_3,
                                            alt: ""
                                          })
                                        ], 16)
                                      ]),
                                      default: _withCtx(() => [
                                        _createElementVNode("div", { class: "media-modal__item-menu" }, [
                                          _createElementVNode("div", {
                                            class: "media-modal__item-menu-item",
                                            onClick: ($event: any) => (downloadAttachment(media))
                                          }, [
                                            _createVNode(_component_v_icon, { icon: "mdi-download" }),
                                            _createElementVNode("p", null, "Download")
                                          ], 8, ["onClick"]),
                                          _createElementVNode("div", {
                                            class: "media-modal__item-menu-item",
                                            onClick: ($event: any) => (deleteAttachment(media))
                                          }, [
                                            _createVNode(_component_v_icon, { icon: "mdi-delete" }),
                                            _createElementVNode("p", null, "Delete")
                                          ], 8, ["onClick"])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createElementVNode("div", { class: "media-modal__item-image" }, [
                                      (isImageType(media?.mediaUrl))
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            loading: "lazy",
                                            src: 
                          media?.mediaUrl
                            ? media?.mediaUrl
                            : require('@/assets/images/media-image.jpg')
                        ,
                                            alt: "img"
                                          }, null, 8, ["src"]))
                                        : (_openBlock(), _createElementBlock("img", {
                                            key: 1,
                                            src: require('@/assets/icons/documents.svg'),
                                            alt: "icon"
                                          }, null, 8, ["src"]))
                                    ]),
                                    _createElementVNode("div", { class: "media-modal__item-title" }, [
                                      _createElementVNode("p", null, _toDisplayString(media.originalName), 1)
                                    ]),
                                    _createElementVNode("div", { class: "media-modal__item-info" }, [
                                      _createElementVNode("p", null, [
                                        _createTextVNode(_toDisplayString(media?.meta?.size) + " ", 1),
                                        _createElementVNode("span", null, "•"),
                                        _createTextVNode(" " + _toDisplayString(formatDate(media.dateCreated)
                            ? formatDate(media.dateCreated)
                            : ""), 1)
                                      ])
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]),
                  key: "2"
                }
              : undefined
      ]), 1024)
    ], 2)), [
      [_directive_click_outside, closeEmojiPicker]
    ]),
    (isShowCloseDisputeModal.value)
      ? (_openBlock(), _createBlock(CloseDisputeModal, {
          key: 0,
          onOnClose: onCloseDispute,
          onOnProceedCloseDispute: onConfirmCloseDispute
        }))
      : _createCommentVNode("", true),
    (isShowOfferDisputeModal.value)
      ? (_openBlock(), _createBlock(MakeDisputeOfferModel, {
          key: 1,
          disputeData: __props.userMessageRoomDetails?.dispute,
          onOnSubmit: submitDisputeOffer,
          onOnClose: toggleCloseOfferDispute
        }, null, 8, ["disputeData"]))
      : _createCommentVNode("", true),
    (isViewOfferModal.value)
      ? (_openBlock(), _createBlock(ViewOfferProjectModel, {
          key: 2,
          statement: selectedUserMessage.value.statement,
          isShowButton: !isDisputeAccepted.value,
          userMessageAttachments: selectedUserMessage.value.attachments,
          isSenderUser: selectedUserMessage.value.isSender,
          disputeOffer: selectedUserMessage.value.disputeOffer,
          messageId: selectedUserMessage.value.messageId,
          onOnAcceptOffer: onAcceptOffer,
          onOnRejectOffer: onRejectOffer,
          onOnClose: toggleViewOfferModal
        }, null, 8, ["statement", "isShowButton", "userMessageAttachments", "isSenderUser", "disputeOffer", "messageId"]))
      : _createCommentVNode("", true),
    (isViewEvidenceModal.value)
      ? (_openBlock(), _createBlock(ViewEvidenceAttachmentModal, {
          key: 3,
          evidenceAttachment: selectedUserMessage.value.evidenceData,
          onOnClose: toggleViewEvidenceModal
        }, null, 8, ["evidenceAttachment"]))
      : _createCommentVNode("", true),
    (isShowConfirmRejectCloseDisputeModal.value)
      ? (_openBlock(), _createBlock(ConfirmRejectDisputeModal, {
          key: 4,
          onOnClose: onCloseRejectCloseDisputeModal,
          onOnProceedRejectCloseRequest: onConfirmRejectCloseDispute
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})